module.exports = __webpack_public_path__ + "media/images/partner-14-cfb21dd64c1e6be122901c2599809a76.png";